import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Mobile, AL?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through the Mobile Main Post Office can take 2–6 months. For Port of Mobile cruise passengers with imminent departures, Austal USA engineers with project trips to Australia, and USA medical students with international rotations, that timeline is simply not viable.",
  },
  {
    q: "Can I get a passport for a cruise departing from the Port of Mobile?",
    a: "Yes, and this is one of our most common scenarios. The Alabama Cruise Terminal at the Port of Mobile serves Caribbean cruises each season, and passengers frequently discover passport problems days before departure. If your cruise departs within 14 days, we can process an emergency passport in 24–72 hours. Do not show up at the cruise terminal with an expired passport — they cannot help you there.",
  },
  {
    q: "Can Austal USA employees get expedited passports for Australia travel?",
    a: "Absolutely. Austal USA, the Mobile shipyard subsidiary of Australian shipbuilder Austal, employs thousands of workers who travel regularly to Perth, the Philippines, and other Austal locations. Contracts are often awarded on short notice, and teams need to deploy quickly. We regularly process expedited renewals and new applications for Austal engineers, project managers, and executives.",
  },
  {
    q: "Where is the Mobile passport acceptance facility?",
    a: "The Mobile Main Post Office at 250 St Emanuel St is the primary passport acceptance facility. The Tillmans Corner Post Office also accepts applications with photo service available. Hours are typically Monday–Friday 9:00 AM–4:00 PM. However, these facilities only accept applications — they do not process expedited or emergency requests.",
  },
  {
    q: "Can University of South Alabama medical students get expedited passports?",
    a: "Yes. USA medical and nursing students pursue international rotations in Central America, Africa, and Southeast Asia. Students often discover their passports are expired when they receive their program assignments. We help USA students with fast processing so they do not miss their rotation start dates.",
  },
  {
    q: "How quickly can Saraland, Prichard, and Daphne residents receive expedited passports?",
    a: "Saraland, Prichard, Chickasaw, Tillmans Corner, and Daphne residents have the same access to our expedited services as Mobile residents. Since we operate remotely, your location in the Mobile Bay area does not affect processing speed. Most clients receive their passports within 2–9 business days.",
  },
  {
    q: "Do I need to visit an office to use Fast Passport Center?",
    a: "No — most Mobile travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Mobile, but that is the point: you do not need one. Start your order online, follow the checklist, and ship your documents overnight from anywhere along the Gulf Coast.",
  },
  {
    q: "What documents do I need for an expedited passport?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability. As a registered courier, we offer rates typically 30–100% lower than FedEx, Staples, and other third-party resellers.",
  },
];

export default function MobileFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Mobile and Gulf Coast travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}